namespace TabAurous.Inventory {
    export interface MaterialReturnItemsForm {
        TransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        PartyId: Serenity.IntegerEditor;
        RefVoucherId: Serenity.IntegerEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        HSN: Serenity.LookupEditor;
        LotNo: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        RoutingId: Serenity.DecimalEditor;
        GroupId: Serenity.DecimalEditor;
        Studded: Serenity.IntegerEditor;
        DesignId: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        HasBom: Serenity.BooleanEditor;
        ProductName: Serenity.StringEditor;
        DesignCode: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        UnitRate: Serenity.DecimalEditor;
        StoneRate: AmountEditor;
        OtherRate: AmountEditor;
        NetAmount: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        NetWeight: WeightEditor;
        CalcOnId: Serenity.LookupEditor;
        UnitCost: Serenity.DecimalEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        Attribute: Serenity.StringEditor;
        CalcUnitId: Serenity.LookupEditor;
        KaratId: Serenity.LookupEditor;
        MetalColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: StoneSieveLookup;
        GroupSieveId: StoneSieveLookup;
        Remarks: Serenity.StringEditor;
        IsDisabled: Serenity.BooleanEditor;
        ServerDate: Serenity.DateEditor;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        Lab: Serenity.LookupEditor;
        CertificateNo: Serenity.StringEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
    }

    export class MaterialReturnItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.MaterialReturnItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MaterialReturnItemsForm.init)  {
                MaterialReturnItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.BooleanEditor;
                var w5 = CommonCategoryLookup;
                var w6 = WeightEditor;
                var w7 = AmountEditor;
                var w8 = StoneSieveLookup;
                var w9 = s.DateEditor;

                Q.initFormType(MaterialReturnItemsForm, [
                    'TransId', w0,
                    'TransItemId', w0,
                    'PartyId', w1,
                    'RefVoucherId', w1,
                    'BagNo', w0,
                    'SKU', w0,
                    'HSN', w2,
                    'LotNo', w0,
                    'RefNo', w0,
                    'RoutingId', w3,
                    'GroupId', w3,
                    'Studded', w1,
                    'DesignId', w0,
                    'ItemTypeId', w1,
                    'ProductId', w0,
                    'ProductCode', w0,
                    'HasBom', w4,
                    'ProductName', w0,
                    'DesignCode', w0,
                    'AttributeId', w0,
                    'ProductTypeId', w2,
                    'CategoryId', w5,
                    'SubCategoryId', w2,
                    'Pieces', w1,
                    'Weight', w6,
                    'UnitRate', w3,
                    'StoneRate', w7,
                    'OtherRate', w7,
                    'NetAmount', w3,
                    'GrossAmount', w3,
                    'CCNetAmount', w3,
                    'CCGrossAmount', w3,
                    'NetWeight', w6,
                    'CalcOnId', w2,
                    'UnitCost', w3,
                    'Purity', w3,
                    'PureWeight', w6,
                    'Attribute', w0,
                    'CalcUnitId', w2,
                    'KaratId', w2,
                    'MetalColorId', w2,
                    'QualityId', w2,
                    'ShapeId', w2,
                    'StoneColorId', w2,
                    'StoneSizeId', w2,
                    'SieveId', w8,
                    'GroupSieveId', w8,
                    'Remarks', w0,
                    'IsDisabled', w4,
                    'ServerDate', w9,
                    'StoneCutId', w2,
                    'StonePolishId', w2,
                    'StoneSymmetryId', w2,
                    'StoneFluorescenceId', w2,
                    'StoneCuletId', w2,
                    'StoneGirdleId', w2,
                    'StoneTable', w0,
                    'StoneDepth', w0,
                    'Lab', w2,
                    'CertificateNo', w0,
                    'RefTransItemId', w0,
                    'RefTransId', w0,
                    'Remark', w0,
                    'SpecialRemark', w0,
                    'UserDescription', w0,
                    'AckStatus', w1,
                    'DeliveryDate', w9,
                    'CompanyId', w1,
                    'BagStatus', w0
                ]);
            }
        }
    }
}
